import { DocumentLoader } from '@/components/progress/DocumentLoader';

export function LoadingExternal() {
  return <DocumentLoader />;
}
